export default __webpack_public_path__ + "static/SuisseIntl-b4ea7335f5fc817fc4e2538794f1ec55.woff2";